{
  "emptyState": "Keine ausstehenden FAA-Genehmigungen",
  "unknown": "Unbekannt",
  "headers": {
    "tailNumber": "Kennzeichen",
    "aircraftType": "Flugzeugtyp",
    "fbo": "FBO",
    "submittedBy": "Gesendet von",
    "submitted": "Gesendet",
    "tenant": "Mandant",
    "actions": "Aktionen"
  },
  "tenant": {
    "created": "Erstellt",
    "noTenant": "Kein Mandant"
  },
  "errors": {
    "missingData": "Genehmigung nicht möglich: Flugzeugdaten fehlen. Seite neu laden.",
    "createFaaTail": "Fehler beim Erstellen des FAA-Kennzeicheneintrags: {{message}}",
    "createFaaMapping": "Fehler beim Erstellen der FAA-Zuordnung: {{message}}",
    "markApproved": "Genehmigung fehlgeschlagen: {{message}}",
    "approveFailed": "Genehmigung fehlgeschlagen. Bitte versuche es erneut.",
    "rejectFailed": "Ablehnung fehlgeschlagen. Bitte versuche es erneut."
  },
  "success": {
    "approved": "Genehmigte FAA-Zuordnung für {{tailNumber}} → {{make}} {{model}}",
    "rejected": "Genehmigungsanfrage für {{tailNumber}} abgelehnt"
  }
}
